// RELEASE-TENIS10 § 11 P106 — the child's place in support's correction: ONE field, the cities-only Google search (as the
// Users forms), which shows „Tecuci, Galați, Romania” and fills the county and the country itself; support types nothing
// but the city. A city name Google offers once (the best-known „Tecuci”) is found in another county by typing the county
// after it („Tecuci Teleorman”) — the help line says so. No coordinates are kept (E11).
import React, { useRef, useState } from "react"
import GooglePlacesAutocomplete, { geocodeByPlaceId } from "react-google-places-autocomplete"
import { withFloatingSurface } from "components/Common/selectSurface"
import { childPlaceOf, countyOfPlace, placeText } from "./childPlace"

export default function ChildPlacePicker({ id, label, value, onChange, disabled }) {
  const [failure, setFailure] = useState("")
  const [loading, setLoading] = useState(false)
  // the city support sees: an answer for an older choice is dropped
  const generation = useRef(0)
  const choose = async option => {
    const request = ++generation.current
    setFailure("")
    if (!option) {
      setLoading(false)
      return onChange(null)
    }
    setLoading(true)
    try {
      const [result] = await geocodeByPlaceId(option.value.place_id)
      const place = childPlaceOf(result)
      if (request === generation.current) onChange(place)
    } catch (error) {
      if (request === generation.current) setFailure(error.message || "Could not verify this city. Try again.")
    } finally {
      if (request === generation.current) setLoading(false)
    }
    return undefined
  }
  const county = countyOfPlace(value)
  const state = loading ? "Verifying city…" : failure || (!value ? "Choose the city from the search results."
    : county ? `County ${county} · ${value.country}, from the city you chose.`
      : "No county saved for this city: choose it again to save its county.")
  return <div className="form-group col-12">
    <label htmlFor={id} className="mb-1 font-weight-medium">{label} <span className="text-danger">*</span></label>
    <GooglePlacesAutocomplete apiKey={process.env.REACT_APP_GOOGLE_MAPS_API} apiOptions={{ language: "en" }} minLengthAutocomplete={2}
      autocompletionRequest={{ types: ["(cities)"] }}
      selectProps={{
        styles: withFloatingSurface(), classNamePrefix: "player-select", inputId: id, "aria-label": label, "aria-required": true,
        "aria-invalid": Boolean(failure), "aria-describedby": `${id}-help`,
        value: value ? { label: placeText(value), value } : null, onChange: choose, isClearable: true, isDisabled: disabled, isLoading: loading,
        placeholder: "Search for the city…", noOptionsMessage: () => "Type the city's name",
      }} />
    <small id={`${id}-help`} className={`d-block ${failure ? "text-danger" : county || !value ? "text-muted" : "text-warning"}`}>{state}</small>
    <small className="d-block text-muted">Not the right county? Type it after the city, for example “Tecuci Teleorman”.</small>
  </div>
}
